import { assertExhaustive } from '@fullstory/typeutils';
import React, { ComponentProps, useContext } from 'react';
import { Icon } from '../Icon';
import { BannerContext } from './BannerRoot';

export const BannerIcon: React.FC = () => {
  const { variant } = useContext(BannerContext);

  let iconName: ComponentProps<typeof Icon>['name'] | null = null;
  let iconColor: ComponentProps<typeof Icon>['color'] = undefined;
  switch (variant) {
    case 'default':
      iconName = 'help-fill';
      break;
    case 'success':
      iconName = 'checkmark-fill';
      iconColor = 'success';
      break;
    case 'warning':
      iconName = 'warning-fill';
      iconColor = 'warning';
      break;
    case 'danger':
      iconName = 'clear';
      iconColor = 'destructive';
      break;
    default:
      return assertExhaustive(variant);
  }

  return <Icon data-component="BannerIcon" name={iconName} color={iconColor} size={20} />;
};
